<template>
  <div>
    <b-modal v-model="showModal"
      :title="isResend ? 'Reenviar Activación' : 'Validar Correo'"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="cancel"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc>
      <b-overlay :show="loading" rounded="sm">

        <p>El correo del usuario <strong>{{ code }}</strong> todavía <b>no está validado</b>,
           así que no puede iniciar sesión.</p>

        <!-- Reenviar: la clave se restablece SIEMPRE, porque en base solo hay el hash y
             no hay forma de recuperar la actual para comunicarla. Se avisa antes. -->
        <template v-if="isResend">
          <p class="mb-2">Se enviará a <strong>{{ email }}</strong> un correo con:</p>
          <ul class="mb-3" style="padding-left: 1.1rem; list-style: disc;">
            <li>su usuario y su correo de acceso;</li>
            <li>una <b>contraseña nueva</b>, que será su <b>número de documento</b>;</li>
            <li>el botón para activar la cuenta (válido 48&nbsp;horas).</li>
          </ul>

          <div class="alert alert-warning py-2 px-3 mb-2" style="font-size: 0.85rem;">
            <i class="fas fa-exclamation-triangle fa-fw"></i>
            <b>Su contraseña actual dejará de servir</b> y el enlace de activación anterior
            caducará.
          </div>
        </template>

        <!-- Validar: atajo equivalente a que el usuario pulse el enlace del correo. -->
        <template v-else>
          <p class="mb-3">Al validarlo lo das por bueno sin esperar al correo, y el usuario
             podrá entrar de inmediato con la contraseña que ya tenga.</p>

          <small class="text-muted d-block">
            Validar el correo <b>no</b> desbloquea una cuenta bloqueada: eso se cambia desde
            «Cambiar Estado».
          </small>
        </template>

        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
          <button v-if="isResend" class="btn btn-sm btn-secondary" type="button" @click="send">
            <i class="fas fa-envelope fa-fw"></i> Restablecer y enviar
          </button>
          <button v-else class="btn btn-sm btn-success" type="button" @click="send">
            <i class="fas fa-user-check fa-fw"></i> Validar ahora
          </button>
        </div>

      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal, BOverlay } from 'bootstrap-vue';

export default {
  components: { BModal, BOverlay },
  // mode: 'verify' (validar el correo a mano) | 'resend' (restablecer clave y enviar).
  props: ['id', 'code', 'email', 'mode', 'showModal'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    isResend() {
      return this.mode === 'resend';
    },
  },
  methods: {
    close() {
      this.$emit('update:showModal', false);
      this.$emit('getRecords');
    },
    cancel() {
      this.$emit('update:showModal', false);
    },
    send() {
      const url = this.isResend
        ? '/configuration/users/resendActivation'
        : '/configuration/users/verifyEmail';
      const fallbackMessage = this.isResend
        ? 'No se pudo enviar el correo'
        : 'No se pudo validar el correo';

      this.loading = true;

      axios.post(url, { id: this.id })
        .then(response => {
          if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else if (response.data.mail == 'failed') {
            // La clave YA se restableció: es un aviso, no un error, y la fila debe
            // refrescarse igual.
            toastr.warning(response.data.message, 'Atención', { icon: 'fa fa-exclamation-circle', timeOut: 10000 });
            this.close();
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
            this.close();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            toastr.error(Object.values(errors)[0][0], 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.error(fallbackMessage, 'Error', { icon: 'fa fa-times-circle' });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
}
</script>
